import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class FilterService {
  constructor() { }

  bindFilterGrid(search?) {
    let arr = [];
    //console.log("Search Grid is ",search);
    for(let key in search) {
      //console.log("Key type ",typeof(search[key]));
      if (search.hasOwnProperty(key)) {
        if (search[key] === '' || search[key] == undefined || search[key] === 0 || (search[key] != undefined && Array.isArray(search[key]) && search[key].length === 0)) {

        }
        else {
          if (Array.isArray(search[key]) && search[key].length > 0) {
            arr.push(this.concatArrayValues(key, search[key]));
          }
          else if (typeof (search[key]) == 'object') {
            let x = this.concatObjectValues(key, search[key])
            // if (x == undefined) { } else

            {
              let search_ = search[key] ? search[key] : {};
              arr.push(this.concatObjectValues(key, search[key]));
            }
          } else {
            arr.push(key + ':' + search[key]);
          }
        }
      }
    };
    var filter = arr.join(',');
    //console.log("Filter is ",filter);
    return filter;
  }
  concatObjectValues(key, object) {
    //console.log("Inside ",key, object);
    var x: any;
    for(let a in object) {
      if (key.includes("daterangefilter")) {
        // if (object[a] == '' || object[a] == undefined) { }
        // else
        if (x == undefined || x == '') {
          x = a + ':' + object[a];
        } else {
          x = x + ',' + (a + ':' + object[a]);
        }
      }
      else {
        // if (object[a] == '' || object[a] == undefined) { }
        // else
        if(object[a] != undefined && Array.isArray(object[a]) && object[a].length>0){
          //it is case of search seelct for now hardcoding the value with id
          var arrText = this.concatArrayValues(a,object[a]);
          if (x == undefined || x == '') {
            x = key + '.' + arrText;
          } else {
            x = x + ',' + (key + '.' + arrText);
          }
        }else{
          if (x == undefined || x == '') {
            x = key + '.' + a + ':' + object[a];
          } else {
            x = x + ',' + (key + '.' + a + ':' + object[a]);
          }
        }
        
      }
    }
    // console.log("X is ",x);
    return x ? x : (key + ":" + "");
  }

  concatArrayValues(key, object) {
    //console.log("Inside ",key, object);
    var x: any = [];
    let keyToCheck = object[0].id ? 'id' : 'code'
    for (let a of object) {
      x.push(a[keyToCheck])
    }
    let joinedValues = x.join('#')
    // console.log("X is ",x);
    return (key + ":" + joinedValues);
  }
  removeDuplicateKeysFromString(object) {
    if (object != undefined && object['filter'] != undefined && typeof object['filter'] != 'object') {
      let temp_array = object['filter'].split(',');
      let final_arr = [];
      let temp_array_2 = [];
      for (let i = 0; i < temp_array.length; i++) {
        if (!temp_array_2.includes(temp_array[i].split(':')[0])) {
          //added so that only relivent data should be pushed i.e with valid value
          if (temp_array[i].split(':')[1] != undefined && temp_array[i].split(':')[1] != "" && temp_array[i].split(':')[1] != "null") {
            final_arr.push(temp_array[i]);
          }
          temp_array_2.push(temp_array[i].split(':')[0]);
        }
      }
      return final_arr.join();
    }
  }
}
